import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { ACTIVE_CONVERSATION_QUERY_PARAMETER } from "@redotech/redo-merchant-support-app/query-parameters";
import { SupportPermissions } from "@redotech/redo-model/permissions";
import { matchPath } from "react-router-dom";
import { SupportHelpdesk } from "../../../support-v2/support-helpdesk";
import { prefetchSupportRouteModule } from "../../../support-v2/support-route-prefetch";

const HIDE_PADDING_ROUTES: string[] = [
  "/table/*",
  "/:supportTicketId",
  "/:supportTicketId/rule-execution/:workflowId",
];

function hidePadding(url: string): boolean {
  return HIDE_PADDING_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/support-v2${route}`, url),
  );
}

const FULLSCREEN_ROUTES: string[] = [];

const HIDE_HEADER_ROUTES: string[] = [...FULLSCREEN_ROUTES];
function hideHeader(url: string, { search }: { search: string }): boolean {
  if (search.includes(ACTIVE_CONVERSATION_QUERY_PARAMETER)) {
    return true;
  }

  return HIDE_HEADER_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/support-v2${route}`, url),
  );
}

const HIDE_NAV_ROUTES: string[] = [...FULLSCREEN_ROUTES];

function hideNav(url: string): boolean {
  return HIDE_NAV_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/support-v2${route}`, url),
  );
}

export const SUPPORT_VIEW_NAME = "Support View";

export const supportV2Routes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Support-V2", breadcrumbNavigate: false },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={hideHeader}
            hideNavbar={hideNav}
            hidePadding={hidePadding}
            newChrome
          />
        ),
      };
    },
    children: [
      {
        element: <SupportHelpdesk />,
        children: [
          {
            handle: { breadcrumb: "Attachment Test" },
            path: "attachment-test",
            async lazy() {
              const { AttachmentTest } = await import(
                "../../../support-v2/components/attachment-test"
              );
              return { Component: AttachmentTest };
            },
          },
          {
            path: "dashboard",
            handle: {
              breadcrumb: "Dashboard",
              permission: SupportPermissions.VIEW_ANALYTICS,
            },
            async lazy() {
              const { ConciergeDashboardPage } = await import(
                "@redotech/redo-merchant-support-app/analytics/dashboards/concierge-dashboard-page"
              );
              return { Component: ConciergeDashboardPage };
            },
          },
          {
            handle: { breadcrumb: SUPPORT_VIEW_NAME },
            path: ":supportTicketId",
            children: [
              {
                index: true,
                async lazy() {
                  const { Support } = await prefetchSupportRouteModule();
                  return { Component: Support };
                },
              },
              {
                path: "rule-execution/:workflowId",
                handle: { breadcrumb: "Rule Execution" },
                async lazy() {
                  const { RuleExecutionView } = await import(
                    "../../../support-v2/views/rule-execution-view"
                  );
                  return { Component: RuleExecutionView };
                },
              },
            ],
          },
          {
            handle: { breadcrumb: "Inbox" },
            path: "",
            async lazy() {
              const { SupportTicketsTableView } = await import(
                "../../../support-v2/views/support-tickets-table-view"
              );
              return { Component: SupportTicketsTableView };
            },
          },
        ],
      },
    ],
  },
];
